import $axios from '@/plugins/axios'
import type { AxiosResponse } from 'axios'
import type { IServerResponse } from '@/models/IServerResponse'
import type { IFollowUpDto } from '@/models/IFollowUpDto'
import type { IPaginationResponse } from '@/models/IPaginationResponse'
import type { NoteTypeRelatable } from '@/models/INote'

const resource = 'api/v1/follow_up'

export default {
    getFollowUpByTypeRelatableAndIdRelatableDatatable(
        params: string,
        typeRelatable: NoteTypeRelatable,
        idRelatable: number,
        displayTraceability: boolean
    ): Promise<AxiosResponse<IServerResponse<IPaginationResponse<Array<IFollowUpDto>>>>> {
        return $axios.get(`${resource}/${typeRelatable}/${idRelatable}/datatable?${params}displayTraceability=${displayTraceability}`)
    },

    getFollowUpByTypeRelatableAndIdRelatable(
        idRelatable: number,
        typeRelatable: NoteTypeRelatable
    ): Promise<AxiosResponse<IServerResponse<Array<IFollowUpDto>>>> {
        return $axios.get(`${resource}/${typeRelatable}/${idRelatable}`)
    },
}
